import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";

import { PhX } from "@phosphor-icons/vue";
import OptimizeSignalAsideTipsModalElectronicTip from "@/pages/optimizeSignalAndImpedancePage/aside/components/optimizeSignalAsideTipsModal/components/optimizeSignalAsideTipsModalElectronicTip.vue";
import OptimizeSignalAsideTipsModalCleanTip from "@/pages/optimizeSignalAndImpedancePage/aside/components/optimizeSignalAsideTipsModal/components/optimizeSignalAsideTipsModalCleanTip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptimizeSignalAsideTipsModal',
  props: {
  modalModel: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;



// ---- STATE ----

const carouselModel = ref(0);

// ---- CALLBACKS ----

const handleNextStep = () => {
  if (carouselModel.value === 1) {
    carouselModel.value = 0;
    return;
  }

  carouselModel.value = 1;
};

const handleClose = () => {
  emit("close");
  carouselModel.value = 0;
};

return (_ctx: any,_cache: any) => {
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_VCarouselItem = _resolveComponent("VCarouselItem")!
  const _component_VCarousel = _resolveComponent("VCarousel")!
  const _component_VCard = _resolveComponent("VCard")!
  const _component_VCol = _resolveComponent("VCol")!

  return (__props.modalModel)
    ? (_openBlock(), _createBlock(_component_VCol, {
        key: 0,
        style: {"display":"flex","position":"fixed","top":"0","left":"0","width":"100vw","height":"100vh","background":"rgba(32, 32, 32, 0.73)","box-shadow":"0 8px 32px 0 rgba(31, 38, 135, 0.37)","backdrop-filter":"blur(3.5px)","-webkit-backdrop-filter":"blur(3.5px)","z-index":"1300","justify-content":"center","align-items":"center"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VCard, {
            width: "85vh",
            style: {"top":"50px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VBtn, {
                class: "rounded-circle position-absolute d-flex justify-center align-center",
                onClick: handleClose,
                style: {"top":"15px","right":"15px","min-width":"0 !important","width":"32px","height":"32px","z-index":"10000000"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PhX), { size: "20" })
                ]),
                _: 1
              }),
              _createVNode(_component_VCarousel, {
                "hide-delimiters": "",
                "show-arrows": false,
                modelValue: carouselModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((carouselModel).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VCarouselItem, {
                    class: "h-100",
                    style: {"height":"100%"},
                    value: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(OptimizeSignalAsideTipsModalElectronicTip, { onClose: handleNextStep })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_VCarouselItem, {
                    class: "h-100",
                    style: {"height":"100%"},
                    value: "1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(OptimizeSignalAsideTipsModalCleanTip, { onClose: handleNextStep })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})